<div class="header">
  <div class="search-box-outer">
    <div class="search-box-wrapper" (appClickOutside)="toggleSearchPanel()">
      <div class="search-box" [class.active]="isSearchPanelOpen">
        <app-svg-icon
          iconName="search.svg"
          height="22px"
          width="22px"
          class="search-icon"
        ></app-svg-icon>

        <input
          type="text"
          placeholder="Search features, pages, and more..."
          [(ngModel)]="searchValue"
          (input)="onSearch()"
          (click)="onSearchClick()"
        />

        @if (searchValue) {
          <app-svg-icon
            iconName="close.svg"
            height="18px"
            width="18px"
            class="clear-search-icon"
            (click)="clearSearch()"
            (keyup.enter)="clearSearch()"
            tabindex="0"
            role="button"
            [attr.aria-label]="'Clear search'"
          ></app-svg-icon>
        }
      </div>

      @if (isSearchPanelOpen) {
        <div class="search-panel-wrapper">
          @if (showSuggestions) {
            <ng-container
              *ngTemplateOutlet="suggestionsTemplate"
            ></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="historyTemplate"></ng-container>
          }
        </div>
      }
    </div>
  </div>
</div>

<ng-template #suggestionsTemplate>
  <div class="search-results">
    @if (suggestionsList.length > 0) {
      @for (item of suggestionsList; track item.name) {
        @if (item.name.toLowerCase().startsWith(searchValue.toLowerCase())) {
          <div
            class="result-item parent-route"
            (click)="onSuggestionClick(item)"
            (keyup.enter)="onSuggestionClick(item)"
            tabindex="0"
          >
            <div class="route-icon-wrapper">
              <app-svg-icon
                [iconName]="item.iconURL"
                height="16px"
                width="16px"
                class="route-icon"
              ></app-svg-icon>
            </div>
            <div class="route-info">
              <div class="route-name">{{ item.name }}</div>
            </div>
            <app-svg-icon
              iconName="arrow-right.svg"
              height="16px"
              width="16px"
              class="arrow-icon"
            ></app-svg-icon>
          </div>
        }

        @for (sub of item.sub; track sub.name) {
          <div
            class="result-item sub-route"
            (click)="onSuggestionClick(sub, item.route, item.name)"
            (keyup.enter)="onSuggestionClick(sub, item.route, item.name)"
            tabindex="0"
          >
            <div class="route-icon-wrapper sub">
              <app-svg-icon
                [iconName]="sub.iconURL"
                height="14px"
                width="14px"
                class="route-icon"
              ></app-svg-icon>
            </div>
            <div class="route-info">
              <div class="route-name">{{ sub.name }}</div>
              <div class="route-breadcrumb">
                <span class="parent-label">{{ item.name }}</span>
              </div>
            </div>
            <app-svg-icon
              iconName="arrow-right.svg"
              height="16px"
              width="16px"
              class="arrow-icon"
            ></app-svg-icon>
          </div>
        }
      }
    } @else if (relatedSuggestions.length > 0) {
      <div class="did-you-mean-section">
        <div class="did-you-mean-header">
          <app-svg-icon
            iconName="search.svg"
            height="16px"
            width="16px"
            class="did-you-mean-icon"
          ></app-svg-icon>
          <span class="did-you-mean-title">Did you mean?</span>
        </div>

        @for (item of relatedSuggestions; track item.name) {
          @if (item.sub.length === 0 || !item.sub[0]) {
            <div
              class="result-item related-route"
              (click)="onSuggestionClick(item)"
              (keyup.enter)="onSuggestionClick(item)"
              tabindex="0"
            >
              <div class="route-icon-wrapper">
                <app-svg-icon
                  [iconName]="item.iconURL"
                  height="16px"
                  width="16px"
                  class="route-icon"
                ></app-svg-icon>
              </div>
              <div class="route-info">
                <div class="route-name">{{ item.name }}</div>
              </div>
              <app-svg-icon
                iconName="arrow-right.svg"
                height="16px"
                width="16px"
                class="arrow-icon"
              ></app-svg-icon>
            </div>
          } @else {
            @for (sub of item.sub; track sub.name) {
              <div
                class="result-item related-route sub-route"
                (click)="onSuggestionClick(sub, item.route, item.name)"
                (keyup.enter)="onSuggestionClick(sub, item.route, item.name)"
                tabindex="0"
              >
                <div class="route-icon-wrapper sub">
                  <app-svg-icon
                    [iconName]="sub.iconURL"
                    height="14px"
                    width="14px"
                    class="route-icon"
                  ></app-svg-icon>
                </div>
                <div class="route-info">
                  <div class="route-name">{{ sub.name }}</div>
                  <div class="route-breadcrumb">
                    <span class="parent-label">{{ item.name }}</span>
                  </div>
                </div>
                <app-svg-icon
                  iconName="arrow-right.svg"
                  height="16px"
                  width="16px"
                  class="arrow-icon"
                ></app-svg-icon>
              </div>
            }
          }
        }
      </div>
    } @else {
      <div class="no-results">
        <app-svg-icon
          iconName="search.svg"
          height="30px"
          width="30px"
          class="no-results-icon"
        ></app-svg-icon>
        <div class="no-results-title">No results found</div>
        <div class="no-results-text">
          Try searching for a different feature or page
        </div>
      </div>
    }
    <div
      class="search-record-text"
      (click)="onSearchRecordsClick()"
      (keyup.enter)="onSearchRecordsClick()"
      tabindex="0"
    >
      <div>
        Search in records for <span>"{{ searchValue }}"</span>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <line x1="5" y1="12" x2="19" y2="12"></line>
        <polyline points="12 5 19 12 12 19"></polyline>
      </svg>
    </div>
  </div>
</ng-template>

<ng-template #historyTemplate>
  @if (searchHistory.length > 0) {
    <div class="history-section">
      <div class="section-header">
        <app-svg-icon
          iconName="clock.svg"
          height="13px"
          width="13px"
          class="section-icon"
        ></app-svg-icon>
        <span class="section-title">Recent Searches</span>
      </div>

      <div class="history-list">
        @for (history of searchHistory; track history.menuItem.route) {
          <div class="history-item">
            <div
              class="history-item-content"
              (click)="
                onSuggestionClick(
                  history.menuItem,
                  history.parentRoute,
                  history.parentRouteName
                )
              "
              (keyup.enter)="
                onSuggestionClick(
                  history.menuItem,
                  history.parentRoute,
                  history.parentRouteName
                )
              "
              tabindex="0"
            >
              <div class="history-icon-wrapper">
                <app-svg-icon
                  [iconName]="history.menuItem.iconURL"
                  height="14px"
                  width="14px"
                  class="history-route-icon"
                ></app-svg-icon>
              </div>
              <div class="history-info">
                @if (history.parentRoute) {
                  <div class="history-route-name">
                    {{ history.menuItem.name }}
                  </div>
                  <div class="history-breadcrumb">
                    <span class="parent-label">{{
                      history.parentRouteName
                    }}</span>
                  </div>
                } @else {
                  <div class="history-route-name">
                    {{ history.menuItem.name }}
                  </div>
                }
              </div>
            </div>
            <button
              class="remove-history-btn"
              (click)="removeFromHistory(history); $event.stopPropagation()"
              aria-label="Remove from history"
            >
              <app-svg-icon
                iconName="close.svg"
                height="14px"
                width="14px"
              ></app-svg-icon>
            </button>
          </div>
        }
      </div>
    </div>
  }
</ng-template>
